import { EventName } from 'game/events/eventsName';
import { GameEvent } from 'game/events/gameEvent';
import { DisplayValue } from './DisplayValue';
import { GamePlace } from 'constants/cards';
import { Store } from 'game/store/gameStore';
import { GameName } from 'constants/difficulty';
type ScoreMove = { from: GamePlace; to: GamePlace };
const KLONDIKE_REVEAL_CARD_POINTS = 5;
const KLONDIKE_WASTE_PILE_POINTS = 5;
const KLONDIKE_FOUNDATION_POINTS = 10;
const SPIDER_FOUNDATION_POINTS = 100;
const SPIDER_MOVE_POINTS = -1;

// const FREECELL_FOUNDATION_POINTS = 10; // ? check score rules

export default class ScoreCounter extends DisplayValue {
    constructor() {
        super('score');
        this.addPoints = this.addPoints.bind(this);
        this.subtractPoints = this.subtractPoints.bind(this);
        this.onRevealCard = this.onRevealCard.bind(this);
        this.onUndoRevealCard = this.onUndoRevealCard.bind(this);
        this.resetScore = this.resetScore.bind(this);
        this.onDealStockPile = this.onDealStockPile.bind(this);

        GameEvent.add(EventName.ADD_SCORE, this.addPoints);
        GameEvent.add(EventName.SUBTRACT_SCORE, this.subtractPoints);
        GameEvent.add(EventName.REVEAL_CARD, this.onRevealCard);
        GameEvent.add(EventName.UNDO_REVEAL_CARD, this.onUndoRevealCard);
        GameEvent.add(EventName.RESET_GAME, this.resetScore);
        GameEvent.add(EventName.DEAL_STOCKPILE, this.onDealStockPile);
        GameEvent.add(EventName.GAME_READY, this.resetScore);

        this.updateScoreDisplay();
        this.container.visible = false;
    }

    // Adding points to the current score
    public addPoints({ from, to }: ScoreMove): void {
        const points = this.getScoreValueByMove(from, to);
        Store.score += points;

        this.updateScoreDisplay();
    }

    // Subtracting points from the current score
    public subtractPoints({ from, to }: ScoreMove): void {
        const points = this.getScoreValueByMove(from, to);
        if (Store.isSpider && points === -1) Store.score += points;
        else Store.score -= points;
        this.updateScoreDisplay();
    }

    onDealStockPile() {
        if (Store.isSpider) {
            Store.score -= 1;
            this.updateScoreDisplay();
        }
    }
    public resetScore(): void {
        this.updateScoreDisplay();
    }

    private updateScoreDisplay(): void {
        if (Store.score < 0) Store.score = 0;
        this.value.text = Store.score;
    }

    private getScoreValueByMove(from: GamePlace, to: GamePlace) {
        switch (Store.name) {
            case GameName.KLONDIKE:
                if (from === GamePlace.FOUNDATION && to === GamePlace.TABLEAU) return -KLONDIKE_FOUNDATION_POINTS;
                if (from !== GamePlace.FOUNDATION && to === GamePlace.FOUNDATION) return KLONDIKE_FOUNDATION_POINTS;
                if (from === GamePlace.WASTE_PILE && to === GamePlace.TABLEAU) return KLONDIKE_WASTE_PILE_POINTS;
                break;
            case GameName.SPIDER:
                if (to === GamePlace.FOUNDATION) return SPIDER_FOUNDATION_POINTS;
                if (to === GamePlace.TABLEAU) return SPIDER_MOVE_POINTS;
                break;
            case GameName.FREECELL:
                // if (from === GamePlace.FOUNDATION && to === GamePlace.TABLEAU) return -FREECELL_FOUNDATION_POINTS;
                // if (from == GamePlace.TABLEAU && to === GamePlace.FOUNDATION) return FREECELL_FOUNDATION_POINTS;
                break;
        }
        return 0;
    }

    onRevealCard() {
        if (Store.isKlondike) {
            Store.score += KLONDIKE_REVEAL_CARD_POINTS;
            this.updateScoreDisplay();
        }
    }
    onUndoRevealCard() {
        if (Store.isKlondike) {
            Store.score -= KLONDIKE_REVEAL_CARD_POINTS;
            this.updateScoreDisplay();
        }
    }
}
